import React from 'react'
import poster from '../../assets/center-img.png'
const Poster = () => {
  return (
<div
  className="w-full h-[100vh] bg-center bg-cover relative flex  justify-start items-center flex-col pt-[8rem]"
  style={{ backgroundImage: `url(${poster})` }}
>
  {/* <div className="absolute inset-0 bg-black/40"></div> */}

  <h1 className="relative text-white text-[20px] font-bold">
    Celebrate Day Sale!
  </h1>
  <h1 className="font-gopher font-bold text-center capitalize leading-[100%] text-[40px] md:text-[80px] text-gradient text-center mt-[2rem]">
     Save 25% Of On All 
     <br />
Items Collection
  </h1>
</div>
  )
}

export default Poster